import axios from "axios";
import axiosInstance from "@/lib/axios";
import type {
  ApiSuccessResponse,
  ApiErrorResponse,
  TicketsQueryParams,
  MyPurchasedTicketsResponse,
} from "@/types/tickets";

const TICKETS_URL = "/tickets";

export const getTickets = async (
  params?: TicketsQueryParams
): Promise<ApiSuccessResponse> => {
  try {
    const url = params?.uuid ? `${TICKETS_URL}/${params.uuid}` : TICKETS_URL;
    const res = await axiosInstance.get<ApiSuccessResponse>(url, {
      withCredentials: true,
    });
    return res.data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
};

export const getMyPurchasedTickets = async (): Promise<MyPurchasedTicketsResponse> => {
  try {
    const res = await axiosInstance.get<MyPurchasedTicketsResponse>(
      "/users/me/tickets",
      { withCredentials: true }
    );
    return res.data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      throw err.response?.data;
    }
    throw err;
  }
};
